import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Stock } from 'src/app/shared/models/stock.model';

@Injectable({
  providedIn: 'root'
})
export class StockListService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  public resolveStocks(filter: string, offset: number, limit: number): Observable<object>
  {
    if (filter === '') {
      return this.getAllStocks(offset, limit);
    } else {
      return this.getFilteredStocks(filter, offset, limit);
    }
  }

  /**
   *
   */
  public getAllStocks(offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/stocks`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  private getFilteredStocks(filter: string, offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', filter)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/stocks/search`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param stock
   */
  create(stock: Stock) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .post(`${this.url}/stocks`, stock, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param stock
   */
  update(stock: Stock) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .put(`${this.url}/stocks`, stock, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param id
   */
  delete(id: number) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .delete(`${this.url}/stocks/${id}`, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error);
  }
}
